/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthIssuedCouponSearchResponseDto } from '../../models/auth-issued-coupon-search-response-dto';

export interface AutoIssuedCouponControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 관리자 전용 즐겨찾기 여부
 */
  isFavoriteForAdmin?: boolean;
}

export function autoIssuedCouponControllerSearch(http: HttpClient, rootUrl: string, params: AutoIssuedCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthIssuedCouponSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, autoIssuedCouponControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('isFavoriteForAdmin', params.isFavoriteForAdmin, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthIssuedCouponSearchResponseDto>;
    })
  );
}

autoIssuedCouponControllerSearch.PATH = '/api/auto-issued-coupon';
